import {Injector} from "@angular/core";

export class LocatorService {
    static injector: Injector;
}



// WEBPACK FOOTER //
// ./src/app/locator.service.ts